import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationSubtypeComponent } from './organization-subtype.component';
import {SharedModule} from '../../shared/shared.module';
import {CoreModule} from '../../core.module';
import {AddOrganizationSubtypeComponent} from './add-organization-subtype/add-organization-subtype.component';

@NgModule({
  imports: [
    CommonModule, CoreModule, SharedModule
  ],
  declarations: [
    OrganizationSubtypeComponent,
    AddOrganizationSubtypeComponent
  ],
  exports: [
    OrganizationSubtypeComponent
  ]
})
export class OrganizationSubtypeModule { }
